import PropTypes from 'prop-types';
import React from 'react';

import BWComponent from '../BWComponent';

class ShowMoreText extends BWComponent {
  static propTypes = {
    showAll: PropTypes.bool,
    text: PropTypes.node,
    summary: PropTypes.node.isRequired,
    showAllLinkText: PropTypes.node,
    showLessLinkText: PropTypes.node,
    disable: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.disable = this.props.disable;

    this.showAllLinkText = this.props.showAllLinkText || <div>&nbsp;[Show More]</div>;

    this.showLessLinkText = this.props.showLessLinkText || <div>&nbsp;[Show Less]</div>;

    this.state = {
      showAll: !!props.showAll,
    };
  }

  toggleShowAll = async (event) => {
    event.preventDefault();
    let showAll = !this.state.showAll;
    if (showAll && typeof this.props.onOpen === 'function') {
      this.props.onOpen();
    }
    if (!showAll && typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
    this.setState({
      showAll,
    });
  };

  render() {
    const { text, summary } = this.props;
    const showAllLinkText = this.showAllLinkText;
    const showLessLinkText = this.showLessLinkText;
    const disable = this.disable;

    const { showAll } = this.state;

    let content = text || this.props.children;

    if (!disable) {
      content = showAll ? text || this.props.children : summary;
    } // this is a React Node you cannot concat text or anything to it...

    return (
      <div>
        {content}
        {!disable && (
          <b>
            <button className="link-button" onClick={this.toggleShowAll}>
              {showAll ? showLessLinkText : showAllLinkText}
            </button>
          </b>
        )}
      </div>
    );
  }
}

export default ShowMoreText;
